import { createFeature, createReducer, on } from '@ngrx/store';
import { AuditLogsActions } from './audit-logs.actions';
import { AuditFilters, AuditLogItem } from './models/audit-log.model';

export interface AuditLogsState {
  logs: AuditLogItem[];
  filters: AuditFilters;
  loading: boolean;
}

export const initialState: AuditLogsState = {
  logs: [],
  loading: false,
  filters: {
    search: '',
    action: 'all',
    resource: 'all',
  },
};

const reducer = createReducer(
  initialState,
  on(AuditLogsActions.loadRequested, (state) => ({ ...state, loading: true })),
  on(AuditLogsActions.loadSucceeded, (state, { logs }) => ({
    ...state,
    logs: [...logs],
    loading: false,
  })),
  on(AuditLogsActions.loadFailed, (state) => ({ ...state, loading: false })),
  on(AuditLogsActions.setSearch, (state, { search }) => ({
    ...state,
    filters: { ...state.filters, search },
  })),
  on(AuditLogsActions.setActionFilter, (state, { action }) => ({
    ...state,
    filters: { ...state.filters, action },
  })),
  on(AuditLogsActions.setResourceFilter, (state, { resource }) => ({
    ...state,
    filters: { ...state.filters, resource },
  })),
  on(AuditLogsActions.clearFilters, (state) => ({ ...state, filters: initialState.filters })),
  on(AuditLogsActions.clear, () => initialState),
);

export const auditLogsFeature = createFeature({
  name: 'auditLogs',
  reducer,
});
